import axios from 'axios';
import { setAuthorization, removeAuthorization } from 'config/service/auth-service';
import { handlerError } from 'utils';
import { getAllChildrenCompanies } from 'services/company-service';
import { auth2FA } from 'services/auth-service';
import { cancelAllRequests } from 'config/service/http-service';

export const auth2FAAction = (sessionId, code) => async (dispatch) => {
    try {
        dispatch({ type: 'LOGIN_2FA' });
        const res = await auth2FA(sessionId, code);
        setAuthorization(res.data.authToken.access, res.data.authToken.refresh);
        const resChildren = await getAllChildrenCompanies();
        dispatch({ type: 'LOGIN_SUCCESS', payload: { user: res.data, children: resChildren } });
    } catch (ex) {
        const { errorMessage } = handlerError(ex, false);
        dispatch({
            type: 'LOGIN_2FA_FAIL',
            payload: {
                errorMessage,
                statusCode: ex?.response?.status ?? null
            }
        });
    }
};


export const loginStagingAction = (login, password) => async (dispatch) => {
    let req = {
        login: login,
        password: password,
				app: false,
    };

    try {
        dispatch({ type: 'LOGIN' });
        const res = await axios.post('/auth/login', req);
        dispatch({ type: 'LOGIN_INIT_SUCCESS', payload: { sessionId: res.data?.sessionId } });

    } catch (ex) {
        dispatch({ type: 'LOGIN_FAIL', payload: handlerError(ex, false) });
    }
};

export const loginAction = (login, password) => async (dispatch) => {
    let req = {
        login: login,
        password: password,
        app: false,
    };
    try {
        dispatch({ type: 'LOGIN' });
        const res = await axios.post('/auth/login', req);
        dispatch({ type: 'LOGIN_INIT_SUCCESS', payload: { sessionId: res.data?.sessionId } });
    } catch (ex) {
        dispatch({ type: 'LOGIN_FAIL', payload: handlerError(ex, false) });
    }
};

export const loginCompanyAction = (company) => async (dispatch) => {
    let req = {
        company: company,
    };
    try {
        const res = await axios.post('/auth/matriz', req);
        setAuthorization(res.data.authToken.access, res.data.authToken.refresh);
        dispatch({ type: 'LOGIN_SUCCESS', payload: { user: res.data } });
    } catch (ex) {
        dispatch({ type: 'LOGIN_FAIL', payload: handlerError(ex, false) });
    }
};

export const forgotAction = (login, type, recaptcha) => async (dispatch) => {
    let req = {
        user: login,
        recaptcha: recaptcha,
    };
    try {
        dispatch({ type: 'FORGOT' });
        const response = await axios.post('/auth/forgot', req);
        dispatch({
            type: 'FORGOT_SUCCESS',
            payload: type == 'email'
							? response.data.message
							: 'Enviamos um SMS para a recuperação da sua senha do aplicativo',
        });
    } catch (ex) {
        dispatch({ type: 'FORGOT_FAIL', payload: handlerError(ex, false) });
    }
};

export const getResetAction = (token) => async (dispatch) => {
    let req = {};
    try {
        const res = await axios.post('/auth/reset/' + token, req);
        dispatch({ type: 'GET_RESET_SUCCESS', payload: res.data.data });
    } catch (ex) {
        dispatch({ type: 'RESET_FAIL', payload: handlerError(ex, false) });
    }
};

export const resetAction = (token, password) => async (dispatch) => {
    let req = {
        password: password,
    };
    try {
        dispatch({ type: 'RESET' });
        const res = await axios.post(`/auth/reset/${token}/password`, req);
        dispatch({ type: 'RESET_SUCCESS', payload: res.data.type });
    } catch (ex) {
        dispatch({ type: 'RESET_FAIL', payload: handlerError(ex, false) });
    }
};

export const getProfileAction = () => async (dispatch) => {
    try {
        dispatch({ type: 'LOGIN' });
        const res = await axios.get(`/employee/profile`);
        const resCompany = await axios.get(`/company/current`);
        const resChildren = await getAllChildrenCompanies(false);
        dispatch({ type: 'LOGIN_SUCCESS', payload: { user: res.data, company: resCompany.data.data, children: resChildren } });
    } catch (ex) {
        dispatch({ type: 'LOGIN_FAIL', payload: handlerError(ex, false) });
    }
};

export const logoutAction = () => async (dispatch) => {
    cancelAllRequests();
    dispatch({ type: 'LOGOUT' });
    removeAuthorization();
};
